import { render, staticRenderFns } from "./StoreButtons.vue?vue&type=template&id=f67a0216&scoped=true"
import script from "./StoreButtons.vue?vue&type=script&lang=js"
export * from "./StoreButtons.vue?vue&type=script&lang=js"
import style0 from "./StoreButtons.scss?vue&type=style&index=0&id=f67a0216&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67a0216",
  null
  
)

export default component.exports